// extracted by mini-css-extract-plugin
module.exports = {"PowerHomes":"PowerHomes_PowerHomes__oS5Uh","ef-box":"PowerHomes_ef-box__FZqtA"};